import { ObjectHelpers } from 'Helpers/ObjectHelpers'
import { get } from 'lodash'
import { makeAutoObservable, reaction, runInAction } from 'mobx'
import { FeelGreatAPI } from 'Services/FeelGreat/APIs'
import storeAuth from './User/StoreAuth'
import storeCountry from './Cores/County/StoreCountry'
import StoreProducts from './StoreProducts'
// import moment from 'moment'
import StoreCheckout from 'GlobalStores/Checkout/StoreCheckout';
import { FormatAPIs } from 'Services/FeelGreat/FormatAPIs'

class storeSubScriptions {
    subscriptionAll = []
    subscriptionsList = []
    nextDateDelivery = ''
    selectedFlavor = ''
    flavorItemCode = ''
    qty = 0
    price = 0
    dateOfmonth = ''
    forms = []
    shippingForms = []
    creditCard = []
    fontSize = ''
    orderSpec = null
    scrollY = 0

    isReadyToPlaceOrder = false

    isCancelOldSubscription = null
    isClickOpenSubscriptionDetectModal = false
    ableToShowSubscriptionDetectModal = false
    duplicateAutoship = null
    isCheckingDuplicateAutoship = false
    hasCheckedDuplicateAutoship = false
    duplicateAutoshipCheckError = null
    countryImplementWarningList = ['SGP']
    subscriptionDetectResolver = null

    Init(data) {
        Object.keys(data).map(key => {
            runInAction(() => {
                if (key === 'shippingAddress') {
                    this.forms = data[key].inputs
                    this.shippingForms = data[key].inputs
                }
                if (key === 'order') {
                    this.orderSpec = data[key]
                }
            })

            return true
        })
    }

    IsReadyToPlaceOrder() {
        let allFilled = []
        this.creditCard.map(item => {
            if (item.value.length > 0) {
                allFilled.push(true)
            } else {
                allFilled.push(false)
            }
            return item
        })

        this.isReadyToPlaceOrder = !ObjectHelpers.hasFalseElements(allFilled)
    }

    SetCreditCard(itemToSet, value) {
        this.creditCard.map(item => {
            if (item.key === itemToSet.key) {
                if (value.length === 0) {
                    itemToSet.value = ''
                } else {
                    if (item.args) {
                        const regx = get(itemToSet, 'args.regx', null)
                        let regexPass = false
                        if (regx) {
                            const regex = new RegExp(regx, 'i')
                            if (regex.test(value)) {
                                regexPass = true
                            }
                        } else {
                            regexPass = true
                        }

                        const maxLength = get(itemToSet, 'args.maxLength', null)
                        let maxLengthPass = false
                        if (maxLength) {
                            if (value.length <= maxLength) {
                                maxLengthPass = true
                            }
                        } else {
                            maxLengthPass = true
                        }

                        if (regexPass && maxLengthPass) {
                            item.value = value
                        }
                    } else if (itemToSet.key === 'exp_date') {
                        // item.value = moment(value).format('MM/YY')
                        item.value = [value.month, value.year.slice(2, value.year.length)].join('/')
                    } else {
                        item.value = value
                    }
                }
            }

            return item
        })
        this.IsReadyToPlaceOrder()
    }

    SetCheckoutFormValue(key, value) {
        this.forms.map(item => {
            if (item.key === key) {
                runInAction(() => {
                    item.value = value
                })
            }
            return item
        })
        this.shippingForms.map(item => {
            if (item.key === key) {
                runInAction(() => {
                    item.value = value
                })
            }
            return item
        })
    }

    SetSelectedFlavor(value) {
        runInAction(() => {
            this.selectedFlavor = value
        })
    }

    SetFlavorPrice(value) {
        runInAction(() => {
            this.price = value
        })
    }

    SetSubscriptionsList(value) {
        runInAction(() => {
            this.subscriptionsList = value
        })
    }

    SetFlavorQTY(value) {
        runInAction(() => {
            this.qty = value
        })
    }

    SetFlavorItemCode(value) {
        runInAction(() => {
            this.flavorItemCode = value
        })
    }

    SetDateOfmonth(value) {
        runInAction(() => {
            this.dateOfmonth = value
        })
    }

    //get
    GetCreditCardForm() {
        return this.creditCard
    }

    GetCheckoutForms() {
        return this.forms
    }

    GetShippingForm() {
        return this.shippingForms
    }

    GetFlavorItemCode() {
        return this.flavorItemCode
    }

    GetFlavorQTY() {
        return this.qty
    }

    GetFlavorPrice() {
        return this.price
    }

    GetSelectedFlavor() {
        return this.selectedFlavor
    }

    GetSubscriptionsList() {
        return this.subscriptionsList
    }

    GetNextDateDelivery() {
        return this.nextDateDelivery
    }

    GetDateOfmonth() {
        return this.dateOfmonth
    }

    GetSubscriptionAll() {
        return this.subscriptionAll
    }

    SetSubscriptionAll(value) {
        runInAction(() => {
            this.subscriptionAll = value
        })
    }

    async GetHydraAutoOrders() {

        const response = await FeelGreatAPI.GetSubscriptions(storeAuth.GetToken())

        if (response) {
            const filterData = await Promise.all(
                response.data.items
                    .filter(item => item.market === storeCountry.Country2())
                    .map(async data => {
                        let useData = { ...data }

                        let jpStyle = null
                        if (useData.market === 'JP') {
                            jpStyle = await FeelGreatAPI.GetSubscriptionsItems(storeAuth.GetToken(), data.href)
                            useData = {
                                ...useData,
                                lines: jpStyle?.data?.lines,
                                recurrence: jpStyle?.data?.recurrence,
                                shipToAddress: jpStyle?.data?.shipToAddress,
                                transactions: jpStyle?.data?.transactions,
                                terms: jpStyle?.data?.terms,
                                shippingMethod: jpStyle?.data?.shippingMethod,
                                shipToEmail: jpStyle?.data?.shipToEmail
                            }
                        }
                        return {
                            ...useData,
                            productItem: useData.lines.items
                                .map(lineItem => {
                                    let createdItem = {
                                        ...StoreProducts.GetProductByItemCode(lineItem.item.id.unicity),
                                        quantity: lineItem.quantity
                                    }

                                    return createdItem
                                })
                                .filter(createdItem => Object.keys(createdItem).length > 1)
                        }
                    })
            )


            runInAction(() => {
                this.SetSubscriptionAll(filterData)
            })

            return filterData

        } else {
            runInAction(() => {
                this.SetSubscriptionAll([])
            })
            return []
        }
    }

    SetIsCancelOldSubscription(value) {
        runInAction(() => {
            this.isCancelOldSubscription = value
        })
    }

    GetIsCancelOldSubscription() {
        return this.isCancelOldSubscription
    }

    async HandleAbleToShowSubscriptionDetectModal() {
        if (this.GetHasCheckedDuplicateAutoship()) return

        const haveSubscriptionInCart = StoreCheckout.CheckSubscribeInCart()
        const isOneTimePurchase = StoreCheckout.GetSelectedPurchaseOption() === 'onetime'

        const isCountryImplement = this.countryImplementWarningList.includes(storeCountry.Country3())

        this.SetDuplicateAutoship(null)
        this.SetAbleToShowSubscriptionDetectModal(false)
        this.SetHasCheckedDuplicateAutoship(false)
        this.SetDuplicateAutoshipCheckError(null)

        if (isOneTimePurchase || !haveSubscriptionInCart || !isCountryImplement) {
            this.SetHasCheckedDuplicateAutoship(true)
            return
        }

        this.SetIsCheckingDuplicateAutoship(true)

        try {
            const response = await FormatAPIs.checkDuplicateAutoship({
                countryCode3Alpha: storeCountry.Country3(),
                uuid: StoreCheckout.GetUuid(),
                token: storeAuth.GetToken()
            })
            const duplicateAutoship = response?.data?.is_duplicate === true ? response?.data?.data?.[0] : null
            const hasCancellationData = duplicateAutoship?.autoship_href && duplicateAutoship?.autoship_template_id != null

            if (response?.data?.is_duplicate === true && !hasCancellationData) {
                throw new Error('Duplicate subscription data is incomplete. Please try again.')
            }

            this.SetDuplicateAutoship(hasCancellationData ? duplicateAutoship : null)
            this.SetAbleToShowSubscriptionDetectModal(Boolean(hasCancellationData))
        } catch {
            this.SetDuplicateAutoship(null)
            this.SetAbleToShowSubscriptionDetectModal(false)
            this.SetDuplicateAutoshipCheckError(null)
        } finally {
            this.SetIsCheckingDuplicateAutoship(false)
            this.SetHasCheckedDuplicateAutoship(true)
        }

        return
    }

    SetDuplicateAutoship(value) {
        runInAction(() => {
            this.duplicateAutoship = value
        })
    }

    GetDuplicateAutoship() {
        return this.duplicateAutoship
    }

    SetIsCheckingDuplicateAutoship(value) {
        runInAction(() => {
            this.isCheckingDuplicateAutoship = value
        })
    }

    GetIsCheckingDuplicateAutoship() {
        return this.isCheckingDuplicateAutoship
    }

    SetHasCheckedDuplicateAutoship(value) {
        this.hasCheckedDuplicateAutoship = value
    }

    GetHasCheckedDuplicateAutoship() {
        return this.hasCheckedDuplicateAutoship
    }

    SetDuplicateAutoshipCheckError(value) {
        this.duplicateAutoshipCheckError = value
    }

    GetDuplicateAutoshipCheckError() {
        return this.duplicateAutoshipCheckError
    }

    SetClickOpenSubscriptionDetectModal(value) {
        runInAction(() => {
            this.isClickOpenSubscriptionDetectModal = value
        })
    }

    GetClickOpenSubscriptionDetectModal() {
        return this.isClickOpenSubscriptionDetectModal
    }

    GetAbleToShowSubscriptionDetectModal() {
        return this.ableToShowSubscriptionDetectModal
    }

    SetAbleToShowSubscriptionDetectModal(value) {
        runInAction(() => {
            this.ableToShowSubscriptionDetectModal = value
        })
    }

    HandleWaitingSubscriptionDetectModal() {
        return new Promise(resolve => {
            this.subscriptionDetectResolver = resolve
        })
    }

    ResolveSubscriptionDetectModal(shouldPlaceOrder) {
        this.subscriptionDetectResolver?.(shouldPlaceOrder)
        this.subscriptionDetectResolver = null
    }

    constructor() {
        makeAutoObservable(this, { subscriptionDetectResolver: false })
    }
}
const StoreSubScriptions = new storeSubScriptions()
export default StoreSubScriptions
